document.addEventListener('DOMContentLoaded' , () =>{
	//search-product-lists-page
	if(document.querySelector('.filter')){
		const filter = document.querySelector('.js_filter_area'),
			  filterOpen = document.querySelector('.js_filterOpen'),
			  filterBgAdd = document.createElement('div'),
			  filterToggleBtn = document.querySelectorAll('.js_filter_toggleBtn');

		filterOpen.addEventListener('click' , () =>{
			filterBgAdd.classList.add('filter-bg');
			filterBgAdd.classList.add('js_filterClose');
			filter.after(filterBgAdd);
			filter.classList.add('active');
		
			let filterClose = document.querySelectorAll('.js_filterClose'),
				filterBg = document.querySelector('.filter-bg');

			filterClose.forEach(function(el){
				el.addEventListener('click' , function(){
					filter.classList.remove('active');
					filterBg.remove();
				});
			})
		})
		
		filterToggleBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				el.classList.toggle('active');
			});
		})
	}
})
